// extracted by mini-css-extract-plugin
export default {"header-text":"User_header-text__RNAj-","page-main":"User_page-main__3ElDJ","table":"User_table__fKnxu"};